<div [class.selected]="selected" class="filter-tag-container" (click)="selected ? clearFilter() : selectFilter()">
  <i *ngIf="filterTag.icon" [ngClass]="filterTag.icon"></i>
  <span class="u-ls no-hover d-flex d-align-center" [class.u-medium-grey]="!selected">
    <span class="tag-label">{{ filterTag.label | translate }}</span>
  </span>
  <ion-icon *ngIf="filterTag.subSections" class="icon-dropdown" name="chevron-down-outline" (click)="sendDropdown()">
  </ion-icon>
  <ion-icon *ngIf="selected" class="icon-unselect" name="close-circle-outline"></ion-icon>
</div>
